import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=6ee6d5b6&"
import script from "./Create.vue?vue&type=script&lang=ts&"
export * from "./Create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ee6d5b6')) {
      api.createRecord('6ee6d5b6', component.options)
    } else {
      api.reload('6ee6d5b6', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=6ee6d5b6&", function () {
      api.rerender('6ee6d5b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Create.vue"
export default component.exports